import styled from "styled-components";
import { motion } from "framer-motion";


const MAIN = {
  mint: "#5d87ff",
  darkText: "#132028",
  grayText: "#6b7378",
  bgLight: "#f7f9fa",
};
//const PC = "1200px";
const PC = "1200px";
const TABLET = "768px";
const MOBILE = "480px";

/* GLOBAL */
const Page = styled.div`
  font-family: "Inter", "Noto Sans KR", system-ui, -apple-system, "Segoe UI",
    Roboto, "Helvetica Neue", Arial;
  color: ${MAIN.darkText};
  background: rgba(var(--bs-white-rgb), var(--bs-bg-opacity));
  -webkit-font-smoothing: antialiased;
  font-size: 1rem;
  overflow-x: hidden;
`;

const Container = styled.div`
  max-width: 85rem;
  margin: 0 auto;
  padding: 0 2rem;

  @media (max-width: 767px) {
    padding: 0 1.2rem;
  }
`;

/* TITLES */
const SectionTitle = styled.h2`
  font-size: 2.4rem;
  margin: 1rem 0;
  font-weight: 800;
  text-align: center;

  .responsive-br {
    display: none;
  }

  @media (max-width: ${PC}) {
    font-size: 2.1rem;
  }

  @media (max-width: ${MOBILE}) {
    font-size: 1.6rem;

    .responsive-br {
      display: block;
    }
  }
`;

const TitleH2 = styled.h2`
  font-size: 2.4rem;
  margin: 1rem 0 3rem;
  font-weight: 800;
  text-align: center;

  @media (max-width: ${PC}) {
    font-size: 2.1rem;
  }

  @media (max-width: ${MOBILE}) {
    font-size: 1.6rem;
    margin-bottom: 2rem;
  }
`;

const SectionSubtitle = styled.p`
  font-size: 1.2rem;
  color: ${MAIN.grayText};
  margin-bottom: 2.5rem;
  text-align: center;

  br {
    display: inline;
  }

  @media (max-width: ${PC}) {
    font-size: 1.1rem;
  }

  @media (max-width: ${TABLET}) {
  font-size: 0.9rem;
}

@media (max-width: ${MOBILE}) {
  font-size: 0.85rem;
}
  }
`;

/* HERO */
const Hero = styled.section`
  display: flex;
  gap: 2.5rem;
  align-items: center;
  justify-content: space-between;
  padding: 4.5rem 0 3rem;

  @media (max-width: ${PC}) {
    gap: 2rem;
  }

  @media (max-width: ${TABLET}) {
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }
`;

const HeroLeft = styled.div`
  flex: 1 1 60%;
  max-width: 65rem;

  @media (max-width: ${TABLET}) {
    flex: 1 1 70%;
    max-width: 55rem;
  }

  @media (max-width: ${MOBILE}) {
    width: 100%;
  }
`;

const Kicker = styled.p`
  color: ${MAIN.mint};
  font-weight: 800;
  margin-bottom: 1rem;
  font-size: 3.5rem;

  @media (max-width: ${PC}) {
    font-size: 3.2rem;
  }

  @media (max-width: ${TABLET}) {
    font-size: 2.5rem;
    margin-bottom: 0.4rem;
  }

  @media (max-width: ${MOBILE}) {
    font-size: 2rem;
  }
`;

const Title = styled.h1`
  margin: 0.6rem 0 2rem;
  font-size: 2.5rem;
  line-height: 1.2;
  font-weight: 700;

  @media (max-width: ${PC}) {
    font-size: 2.2rem;
  }

  @media (max-width: ${TABLET}) {
    font-size: 1.6rem;
    line-height: 1.4;
  }

  @media (max-width: ${MOBILE}) {
    font-size: 1.3rem;
  }
`;

const Subtitle = styled.p`
  margin: 0 0 0.6rem;
  color: ${MAIN.grayText};
  font-size: 1.2rem;
  font-weight: 500;

  @media (max-width: ${PC}) {
    font-size: 1.05rem;
  }

  @media (max-width: ${TABLET}) {
    font-size: 0.95rem;
  }

  @media (max-width: ${MOBILE}) {
    font-size: 0.9rem;
  }
`;

const Ctas = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-top: 1.2rem;

  @media (max-width: ${TABLET}) {
    justify-content: center;
  }

  @media (max-width: ${MOBILE}) {
    flex-wrap: wrap;
    gap: 0.6rem;
  }
`;

const PrimaryBtn = styled.button`
  background: ${MAIN.mint};
  color: white;
  border: none;
  padding: 0.9rem 1.6rem;
  border-radius: 0.75rem;
  font-weight: 600;
  font-size: 1.1rem;
  cursor: pointer;
  box-shadow: 0 0.625rem 1.25rem rgba(93, 135, 255, 0.35);
  transition: 0.15s ease;

  &:hover {
    transform: translateY(-0.2rem);
    box-shadow: 0 0.625rem 1.6rem rgba(93, 135, 255, 0.5);
  }

  @media (max-width: ${MOBILE}) {
    font-size: 1rem;
    padding: 0.8rem 1.5rem;
  }
`;

const HeroRight = styled.div`
  flex: 1 1 24rem;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: ${TABLET}) {
    width: 100%;
  }
`;

const PersonBlock = styled(motion.div)`
  width: 24rem;
  height: 42rem;
  border-radius: 1.1rem;
  background: linear-gradient(180deg, #fff 0%, #f4f7ff 100%);
  box-shadow: 0 0.625rem 2rem rgba(93, 135, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  @media (max-width: ${TABLET}) {
    width: 18rem;
    height: 30rem;
  }

  @media (max-width: ${MOBILE}) {
    width: 14rem;
    height: 22rem;
  }
`;

const MainImage = styled.img`
  width: 90%;
  object-fit: contain;
  opacity: 0.95;
  transition: transform 0.3s ease, opacity 0.4s ease;

  @media (max-width: ${TABLET}) {
    width: 75%;
  }

  @media (max-width: ${MOBILE}) {
    width: 70%;
  }

  &:hover {
    transform: scale(1.05);
    opacity: 1;
  }
`;
/* FEATURES */
const FeaturesWrap = styled.section`
  margin-top: 1rem;
  padding-bottom: 2rem;

  @media (max-width: ${MOBILE}) {
    padding: 1rem 0;
  }
`;

const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(17rem, 1fr));
  gap: 1.25rem;
white-space: normal;
word-break: keep-all;    /* 한글 단어 단위 줄바꿈 */
overflow-wrap: break-word;

  @media (max-width: ${TABLET}) {
    grid-template-columns: repeat(auto-fit, minmax(14rem, 1fr));
    gap: 1rem;
  }

  @media (max-width: ${MOBILE}) {
    grid-template-columns: 1fr;
    gap: 0.8rem;
  }
`;

const FeatureCard = styled(motion.div)`
  background: white;
  border-radius: 0.9rem;
  padding: 2rem 1rem;
  box-shadow: 0 0.9rem 2rem rgba(20, 30, 40, 0.06);
  text-align: center;
  border: 1px solid #f0f3f4;
  transition: all 0.25s ease;

  &:hover {
    transform: translateY(-0.4rem) scale(1.05);
    box-shadow: 0 1.2rem 2.5rem rgba(93, 135, 255, 0.2);
    border-color: #5d87ff;
  }

  /* 모바일 hover 제거 */
  @media (hover: none) {
    &:hover {
      transform: none;
      box-shadow: none;
    }
  }

  @media (max-width: ${TABLET}) {
    padding: 1.6rem 1rem;
  }

  @media (max-width: ${MOBILE}) {
    padding: 1.4rem 1rem;
  }
`;

const FeatureIcon = styled.div`
  width: 3.5rem;
  height: 3.5rem;
  background: ${MAIN.mint};
  border-radius: 0.75rem;
  margin: 0 auto 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 800;
  font-size: 1.4rem;

  @media (max-width: ${MOBILE}) {
    width: 3rem;
    height: 3rem;
    font-size: 1.2rem;
  }
`;

const FeatureTitle = styled.h3`
  font-size: 1.4rem;
  margin-bottom: 0.4rem;
  color: ${MAIN.darkText};
  font-weight: 700;

  @media (max-width: ${MOBILE}) {
    font-size: 1.2rem;
  }
`;

const FeatureDesc = styled.p`
  font-size: 0.95rem;
  padding: 0 0.3rem;
  color: ${MAIN.grayText};
  font-weight: 500;

  @media (max-width: ${MOBILE}) {
    font-size: 0.85rem;
  }
`;

const FeatureMore = styled.div`
  margin-top: 0.8rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: ${MAIN.mint};
  opacity: 0.8;
  transition: 0.2s ease;

  ${FeatureCard}:hover & {
    opacity: 1;
    transform: translateY(-2px);
  }

  @media (max-width: ${MOBILE}) {
    font-size: 0.8rem;
  }
`;

/* PARTNERS */
const PartnersSection = styled.section`
  padding: 3rem 0;
  background: ${MAIN.bgLight};

  @media (max-width: ${TABLET}) {
    padding: 2rem 0;
  }

  @media (max-width: ${MOBILE}) {
    padding: 1.5rem 0;
  }
`;

const PartnersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));
  gap: 1rem;

  @media (max-width: ${TABLET}) {
    grid-template-columns: repeat(auto-fit, minmax(14rem, 1fr));
    gap: 0.8rem;
  }

  @media (max-width: ${MOBILE}) {
    grid-template-columns: 1fr;
    gap: 0.8rem;
  }
`;

const PartnerCard = styled(motion.div)`
  background: white;
  border-radius: 0.9rem;
  padding: 2rem;
  box-shadow: 0 0.5rem 1.2rem rgba(20, 30, 40, 0.06);
  text-align: center;
  border: 1px solid #f0f3f4;
  transition: all 0.25s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 1rem 2rem rgba(93, 135, 255, 0.2);
    border-color: #5d87ff;
  }

  @media (hover: none) {
    &:hover {
      transform: none;
      box-shadow: none;
    }
  }

  @media (max-width: ${TABLET}) {
    padding: 1.6rem;
  }

  @media (max-width: ${MOBILE}) {
    padding: 1.4rem;
  }
`;

const PLogo = styled.div`
  width: 5rem;
  height: 4rem;
  border-radius: 0.6rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: -2.5rem 0 1rem 0; /* 좌우 auto 제거 */

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

    @media (max-width: ${TABLET}) {
    width: 5.2rem;
    height: 4.5rem;
    margin: -2rem 0 0.8rem 0; 
  }

  /* 모바일 대응 */
  @media (max-width: ${MOBILE}) {
    width: 4rem;
    height: 3rem;
    margin: -1.5rem 0 0.6rem 0; 
  }
`;

const PInfo = styled.div`
  h4 {
    margin: 0.5rem;
    font-size: 1.3rem;
    color: ${MAIN.darkText};
    font-weight: 700;

    @media (max-width: ${MOBILE}) {
      font-size: 1.15rem;
    }
  }

  p {
    margin: 1rem 0 0.6rem;
    color: ${MAIN.grayText};
    font-size: 1rem;
    font-weight: 700;

    white-space: normal;
    word-break: keep-all;    /* 한글 단어 단위 줄바꿈 */
    overflow-wrap: break-word;

    @media (max-width: ${MOBILE}) {
      font-size: 0.9rem;
    }
  }
    
  .tags {
  margin-top: 0.8rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  //grid-template-columns: repeat(2, minmax(8rem, 1fr));
  gap: 0.5rem 0.2rem;
  width: 100%;           
  justify-items: center;  /* 셀 내부 컨텐츠 중앙 정렬 */
  white-space: normal;
  word-break: keep-all;    /* 한글 단어 단위 줄바꿈 */
  overflow-wrap: break-word;

  @media (max-width: ${MOBILE}) {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.4rem;
  }
}
`;

/* MODAL */
const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 0.75rem;
  padding: 2rem;
  
  width: 42rem;
  max-width: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2.5rem;
  position: relative;

  img {
    width: 18rem;
    height: auto;
    object-fit: contain;
    flex-shrink: 0;
  }

  .textContent {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;

    h3 {
      margin: 0;
      color: ${MAIN.mint};
      font-size: 2rem;
      line-height: 2.6rem;
      font-weight: 800;
    }

    p {
      margin-top: 0.5rem;
      color: ${MAIN.darkText};
      font-size: 1.2rem;
      white-space: pre-line;
      line-height: 1.6rem;
    }
  }

  @media (max-width: 900px) {
    width: 34rem;
    padding: 1.8rem;
    gap: 1.5rem;

    img {
      width: 14rem;
    }
  }

  @media (max-width:${MOBILE}) {
    width: 100%;
    flex-direction: column;
    padding: 1.4rem 1rem;
    gap: 1rem;

    img {
      width: 9rem;
      margin: 0 auto;
    }

    .textContent {
      align-items: center;
      text-align: center;

      h3 {
        font-size: 1.5rem;
      }

      p {
        font-size: 0.95rem;
        line-height: 1.3rem;
      }
    }
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 0.75rem;
  right: 0.9rem;
  background: transparent;
  border: none;
  font-size: 2.5rem;
  color: ${MAIN.grayText};
  cursor: pointer;
`;

/* RESULTS SECTION */
const Results = styled.section`
  padding: 3rem 0 5rem;

  @media (max-width:${MOBILE}) {
    padding: 2rem 0 4rem;
  }
`;

const ReferenceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(1rem, 1fr));
  gap: 2rem;
  margin-top: 2rem;
  justify-items: center;

  @media (max-width: 70rem) {
    grid-template-columns: 1fr;
  }
`;

const ReferenceCard = styled(motion.div)`
  display: flex;
  grid-template-columns: repeat(auto-fit, minmax(1rem, 1fr));
  background: white;
  border-radius: 1rem;
  box-shadow: 0 0.5rem 1.2rem rgba(20, 30, 40, 0.08);
  overflow: hidden;
  transition: all 0.3s ease;
  padding: 1.5rem;
  gap: 1.2rem;

  max-width: 1200px;
  margin: 0 auto;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 0.7rem 1.4rem rgba(20, 30, 40, 0.12);
  }

  /* LEFT IMAGE */
  .left {
    flex: 0.9; /* 이미지 크기 조정 */
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: auto;
      border-radius: 0.6rem;
    }
  }

  /* RIGHT CONTENT */
  .right {
    flex: 1.4;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;

    h4 {
      font-size: 1.1rem;
      font-weight: 800;
      text-align: left;
      color: ${MAIN.darkText};
      margin-bottom: 0.4rem;
    }

    .chart-wrap {
      width: 100%;
      height: 130px;
    }

    .average {
      font-size: 0.85rem;
      color: ${MAIN.grayText};
      text-align: center;

    }

    .meta {
      font-size: 1rem;
      line-height: 1.5rem;
      div {
        margin-bottom: 0.25rem;
        strong {
          color: ${MAIN.mint};
        }
      }
    }
  }

  /* Tablet */
  @media (max-width: 900px) {
    max-width: 95%;
  }

  /* Mobile */
  @media  (max-width: 600px) {
    flex-direction: column;

    .left img {
      width: 90%;
    }

    .chart-wrap {
      height: 110px;
    }

    .right {
      align-items: center;
      text-align: center;
    }
  }
`;
const Tag = styled.span`
  display: inline-block;
  color: black;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 1rem;
  padding: 0.35rem 0.4rem;
  text-align: center;
  width: 90%;
  border: 1.5px solid #5d87ff;
  background: transparent;
  transition: background 0.25s ease;

  &:hover {
    background: #b2c5fe;
  }

  @media (max-width: 600px) {
    width: 100%;
    font-size: 0.7rem;
    width: 85%;
  }
`;

/* Animations */
const fadeUp = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 },
};

const slideLeft = {
    hidden: { opacity: 0, x: 30 },
    show: { opacity: 1, x: 0 },
};

const slideRight = {
    hidden: { opacity: 0, x: -30 },
    show: { opacity: 1, x: 0 },
};

export {
    MAIN,Page,Container,Hero,HeroLeft,Kicker,Title,Subtitle,Ctas,PrimaryBtn,HeroRight,PersonBlock,
    MainImage,FeaturesWrap,FeatureGrid,FeatureCard,FeatureIcon,FeatureTitle,FeatureDesc,PartnersSection,PartnersGrid,
    PartnerCard,PLogo,PInfo,ModalOverlay,ModalContent,CloseButton,Results,ReferenceGrid,ReferenceCard,Tag,
    fadeUp,slideLeft,slideRight,SectionTitle,SectionSubtitle,TitleH2,FeatureMore
};